module.exports = __webpack_public_path__ + "img/ico_badge05.dd8dd6db.svg";